import { default as ContentBlock } from './ContentBlock';

export default ContentBlock;
